import { Step } from "@storebrand-digital/insurance-stepper";
import { MainPath } from "Constants/constants";

export const CHECKOUT_STEPS: Step[] = [
  {
    id: "offer",
    title: "Tilbudet ditt",
    ariaLabel: `${MainPath.CHECKOUT}-offer`,
    complete: false,
  },
  {
    id: "order-insurance",
    title: "Bestill forsikring",
    ariaLabel: `${MainPath.CHECKOUT}-order-insurance`,
    complete: false,
  },
];
